import clsx from "clsx";
import translate from "../locales";
import { CloseIcon, TooltipIcon } from "./icons";
import { ReactElement, useContext, useRef } from "react";
import { LanguageContext } from "../app";
export function Tooltip({
  className,
  children,
}: {
  className?: string;
  children: ReactElement;
}) {
  const detailsElement = useRef();
  const language = useContext(LanguageContext);

  return (
    <>
      <button
        className="tooltip__show"
        title={translate("layout.tooltip_open", {}, language)}
        onClick={(e) => {
          e.preventDefault();
          detailsElement.current?.showModal();
        }}
      >
        <TooltipIcon />
      </button>

      <dialog ref={detailsElement} className={clsx("tooltip", className)}>
        <span className="tooltip__icon">
          <TooltipIcon />
        </span>

        <div className="tooltip__content">{children}</div>

        <button
          className="tooltip__close"
          onClick={(e) => {
            e.preventDefault();
            detailsElement.current?.close();
          }}
        >
          <span>{translate("layout.tooltip_close")}</span>
          <CloseIcon />
        </button>
      </dialog>
    </>
  );
}
